import { mapRatingValueToEmoji } from 'domains/survey'
import { generateSatisfactionRatingLink } from 'components/GenerateEmbedCodeModal/utils'
import { sortChoicesForDisplay } from 'libs/questions'

// HARDCODE intercom_text to assign soucre='intercom_text' on rating link
export const INTERCOM_TEXT_SOUCRE = 'intercom_text'

/**
 *
 * @param {object} primaryQuestion
 * @param {object} language
 * @param {object} placeholders
 * @param {string} surveyToken
 * @param {boolean} surveyToken
 * @returns {string}
 */
export function getIntercomCSATEmbedCode(
  primaryQuestion,
  surveyToken,
  placeholders,
  language,
  isReverseOrder
) {
  const questionEmbedCode = `<h2>${primaryQuestion.text}</h2>`
  // Canonical positive-first sort when isReverseOrder=false, reversed to
  // negative-first when true. Raw builder order is not stable across surveys
  // so we normalise here to match PET-1967 canonical direction.
  const choices = sortChoicesForDisplay(primaryQuestion, isReverseOrder)
  const choicesEmbedCode = choices.reduce((html, choice) => {
    return html + _generateEmojiCSATEmbedCode(choice.value, surveyToken, placeholders, language)
  }, '')

  return `${questionEmbedCode}<p>${choicesEmbedCode}</p>`
}

/**
 *
 * @param {number} rating
 * @param {string} surveyToken
 * @param {object} placeholders
 * @param {object} language
 * @returns {string}
 */
function _generateEmojiCSATEmbedCode(rating, surveyToken, placeholders, language) {
  const isRemovePlaceholder = false

  const satisfactionLink = generateSatisfactionRatingLink(
    rating,
    surveyToken,
    placeholders,
    INTERCOM_TEXT_SOUCRE,
    isRemovePlaceholder
  )
  const shortLabel = language[`short_choice_label_${rating}`]
  const emoji = mapRatingValueToEmoji(rating.toString())
  return `<a href="${satisfactionLink}" target="_blank" rel="noopener">${shortLabel} ${emoji}</a> &nbsp; `
}

/**
 *
 * @param {object} primaryQuestion
 * @param {string} surveyToken
 * @param {object} placeholders
 * @param {boolean} [isReverseOrder] applied for CES (metric-agnostic caller);
 *   ignored for NPS which is value-keyed and out of scope for PET-1967.
 * @returns {string}
 */
export function getIntercomNPSEmbedCode(
  primaryQuestion,
  surveyToken,
  placeholders,
  isReverseOrder = false
) {
  const questionEmbedCode = `<h2>${primaryQuestion.text}</h2>`
  // Only CES honors the flip via this function — NPS is value-keyed and out of
  // scope for PET-1967, so it bypasses the canonical sort entirely.
  const isCES = primaryQuestion.metric === 'CES'
  const choices = isCES
    ? sortChoicesForDisplay(primaryQuestion, isReverseOrder)
    : primaryQuestion.choices
  const choicesEmbedCode = choices.reduce((html, choice) => {
    return html + _generateEmojiNPSEmbedCode(choice.value, surveyToken, placeholders)
  }, '')
  return `${questionEmbedCode}<p>${choicesEmbedCode}</p>`
}

/**
 *
 * @param {number} rating
 * @param {string} surveyToken
 * @param {object} placeholders
 * @returns {string}
 */
function _generateEmojiNPSEmbedCode(rating, surveyToken, placeholders) {
  const isRemovePlaceholder = false
  const satisfactionLink = generateSatisfactionRatingLink(
    rating,
    surveyToken,
    placeholders,
    INTERCOM_TEXT_SOUCRE,
    isRemovePlaceholder
  )

  const text = _getNPSratingText(`${rating}`)
  return `<a href="${satisfactionLink}" target="_blank" rel="noopener">${text}</a> &nbsp; `
}

/**
 *
 * @param {string} rating
 * @returns
 */
function _getNPSratingText(rating) {
  if (rating === '0') {
    return `😡 ` + rating
  } else if (rating === '10') {
    return rating + ` 😍`
  } else {
    return rating
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomTextPublish/utils.js